import { render, staticRenderFns } from "./MeestReturnsList.vue?vue&type=template&id=b2bda930&scoped=true"
import script from "./MeestReturnsList.vue?vue&type=script&lang=js"
export * from "./MeestReturnsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2bda930",
  null
  
)

export default component.exports